import { render, staticRenderFns } from "./OptimizedShipping.vue?vue&type=template&id=50a58042&"
import script from "./OptimizedShipping.vue?vue&type=script&lang=js&"
export * from "./OptimizedShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports